// Styles for UserListItem component
// Add styled components here if needed in the future
import { Box } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const UserListItemWrapper = styled(Box)`
  border: 1px solid ${({ theme: { palette } }) => palette.border};
  border-radius: ${({ theme: { mp } }) => mp.xs};
  margin-bottom: ${({ theme: { mp } }) => mp.xs};
  margin-top: ${({ theme: { mp } }) => mp.xs};
  &:hover {
    border: 1px solid ${({ theme: { palette } }) => palette.primary};
  }
`
